<flx-modal
  [dismissible]="true"
  (dismiss)="hideModal.emit()"
  class="flx-ds large h-full overflow-y-auto"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    <div class="flex gap-2 items-center">
      <span>{{ workflowName() }}</span>
      <p-tag
        [value]="status()"
        [severity]="instanceStatusTagTypeMap[status()?.toLowerCase()] || 'info'"
        class="flx-tag inline py-1.5"
      />
    </div>
  </div>
  <div class="flx-modal-body">
    <div class="flex flex-col gap-2 divide-y">
      <p-breadcrumb
        [model]="breadcrumbs()"
        class="flx-prime-breadcrumbs block py-4"
      />
      <div class="pt-2">
        <router-outlet name="workflowInstances"></router-outlet>
      </div>
    </div>
  </div>
</flx-modal>
